import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", {
  class: "text-lg text-center",
  id: "modal-title"
}, "Oops!", -1)
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "pb-4" }, "The following errors occurred in trying to render the site:", -1)
const _hoisted_4 = { class: "list-disc" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "pt-5" }, " If this problem persists, please contact the webmaster at corpuscoranicumev@gmail.com. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
            return (_openBlock(), _createElementBlock("li", {
              key: error,
              class: "py-1"
            }, _toDisplayString(`${error.error} for url '${error.url}'`), 1))
          }), 128))
        ]),
        _hoisted_5
      ])
    ]),
    _: 1
  }))
}